﻿<template>
    <div class="summary-price section" :hidden="get_Trip_Total() == get_Total()">
        <div class="bg-gray-50 rounded-lg p-2 space-y-2">
            <div class="flex justify-between">
                <span class="text-gray-500">Trip Price</span>
                <span>{{get_Trip_Total()}}</span>
            </div>

            <div v-if="is_Discounted()" class="flex justify-between items-center">
                <span class="text-status-success">
                    Discount
                    <span v-if="show_percentage">{{get_Discount_Percentage()}}</span>
                </span>
                <span class="text-status-success font-semibold">
                    {{get_Discount()}}
                </span>
            </div>
            <div v-if="is_Discounted() && hasAddOns" class="flex justify-between">
                <span class="text-gray-500">Tour Subtotal</span>
                <span>{{get_Full_Total()}}</span>
            </div>
            <div v-if="hasAddOns" class="flex justify-between border-t border-gray-200 pt-2 mt-1">
                <span class="text-gray-500">{{get_AddOnText()}}</span>
                <span>{{get_AddOn_Total()}}</span>
            </div>
        </div>
        <div v-if="show_total" class="flex justify-between items-center mt-4">
            <span class="font-bold text-xl">Total</span>
            <span class="font-bold text-xl">{{get_Total()}}</span>
        </div>
    </div>
</template>

<script lang="ts" src="./trip_summary.ts"></script>